import { stylable } from '../decorators';
export const orderedListSpec = stylable({
  content: 'listItem+',
  attrs: {
    type: {
      default: 'orderedList'
    }
  },
  group: 'list',
  parseDOM: [{
    tag: 'ol'
  }],
  toDOM() {
    return ['ol', 0];
  }
});
export const unorderedListSpec = stylable({
  content: 'listItem+',
  attrs: {
    type: {
      default: 'unorderedList'
    }
  },
  group: 'list',
  parseDOM: [{
    tag: 'ul'
  }],
  toDOM() {
    return ['ul', 0];
  }
});
export const listItemSpec = {
  content: 'paragraph',
  group: 'listItem',
  parseDOM: [{
    tag: 'li'
  }],
  toDOM() {
    return ['li', 0];
  },
  defining: true
};
export const orderedNestedListSpec = {
  content: 'nestedListItem+',
  attrs: {
    type: {
      default: 'orderedNestedList'
    }
  },
  group: 'list',
  parseDOM: [{
    tag: 'ol'
  }],
  toDOM() {
    return ['ol', 0];
  }
};
export const unorderedNestedListSpec = {
  content: 'nestedListItem+',
  attrs: {
    type: {
      default: 'unorderedNestedList'
    }
  },
  group: 'list',
  parseDOM: [{
    tag: 'ul'
  }],
  toDOM() {
    return ['ul', 0];
  }
};
export const nestedListItemSpec = {
  content: 'block (block | list)*',
  defining: true,
  parseDOM: [{
    tag: 'li'
  }],
  toDOM() {
    return ['li', 0];
  }
};